import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

function getInitialLanguage() {
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  if (langParam && ['en', 'pt-BR'].includes(langParam)) {
    return langParam;
  }

  const browserLang = navigator.language || 'en';
  if (browserLang.startsWith('pt')) {
    return 'pt-BR';
  }
  return 'en';
}

const i18nConfig = {
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  ns: ['common', 'recording', 'transcription'],
  defaultNS: 'common',
  debug: process.env.NODE_ENV === 'development',

  interpolation: {
    escapeValue: false, 
  },

  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    allowMultiLoading: true,
    crossDomain: false,
  },

  react: {
    useSuspense: false, 
    bindI18n: 'languageChanged loaded',
    bindI18nStore: 'added removed',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
  },
};

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init(i18nConfig)
  .then(() => {
    console.log('i18next initialized successfully');
  })
  .catch((error) => {
    console.error('Failed to initialize i18next:', error);
  });

export const changeLanguage = async (lang) => {
  try {
    await i18n.changeLanguage(lang);
    const url = new URL(window.location);
    url.searchParams.set('lang', lang);
    window.history.replaceState({}, '', url);
    return true;
  } catch (error) {
    console.error('Failed to change language:', error);
    return false;
  }
};

export const getAvailableLanguages = () => [
  { code: 'en', name: 'English' },
  { code: 'pt-BR', name: 'Português (Brasil)' },
];

export const detectLanguageFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');
  if (lang && lang !== i18n.language) {
    changeLanguage(lang);
  }
};

export default i18n;